import React, { useEffect, useState } from 'react'
import senddata from "../../Data/data.js";
import sendFormData from "../../Data/formData.js";
import logoimg from '../../assets/MK1.3.png';
import { useLocation, useNavigate } from 'react-router-dom';

function Video() {

  const location = useLocation();
  const navigate = useNavigate()
  var {video,course} = location.state;

  const [enableEdit,setEnableEdit] = useState(false);
  const [showOptions,setShowOptions] = useState(1);
  const [exerciseId,setExerciseId] = useState(video.exercise_id);

  const [comments,setComments] = useState([]);
  const [showRply,setShowRply] = useState(false);
  const [currentReply,setCurrentReply] = useState("");
  const [replymessage,setReplymessage] = useState("");

  const [allWatches,setAllWatches] = useState([]);

  // 2-8
  const [newUrl,setNewUrl] = useState("");
  const [allCodes,setAllCodes] = useState([]);

  // 25/8
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileType, setFileType] = useState("pdf");
  const [uploadedFiles, setUploadedFiles] = useState(video.files || []);

  // 25/9
  const [additionalVideos, setAdditionalVideos] = useState(video.additionalVideos || []);
  const [additionalVideoId, setAdditionalVideoId] = useState("");


  useEffect(()=>{
    if(showOptions==2){
      getAllComments();
    }
    if(showOptions==3){
      getAllVideoWatch();
    }
    if(showOptions==4){
      getAllCodes();
    }
  },[showOptions])


  const getExamInVideo = ()=>{
    senddata(`teacher/exam/get_exercise_by_video/${course._id}/${video.id}`,{}, "GET").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال بالانترنت ');
      } else {
        const exam = res.data;
        navigate("/exam",{ state: exam });
      }
    });
  }

  const habdleExercise =()=>{
    if(exerciseId){
      const userResponse = prompt(`امتب Ok لتأكيد حذف السؤال `);
      if(userResponse?.trim() =="ok" ){
        deleteExamInVideo()
      }
    }else{
      localStorage.setItem("videoid_for_video_exam",video.id); 
      localStorage.setItem("courseid_for_video_exam",course._id);
      localStorage.setItem("videoname_for_video_exam",video.description);
      navigate("/examInVideo");
    }
  }

  const deleteExamInVideo = ()=>{
    senddata(`teacher/exam/deleteexerciseinvideo/${exerciseId}`,{}, "DELETE").then((res) => {
      if (res.status !== 200) {
        alert('تأكد من الاتصال بالانترنت ');
      } else {
        setExerciseId("");
      }
    });

  }

  // comments

  // 25/7
  const getAllComments = ()=>{
    senddata(`chat/show_comments_in_video/${video.id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
        } else {
          setComments(res.data);
          setShowRply(false);
        }
        });
    }

    const deleteComment = (comment)=>{
      const userResponse = prompt(`اكتب ok لتأكيد حذف الرد `);
      if(userResponse?.trim() =="ok" ){
          senddata(`chat/reply_on_comment/${comment._id}`,{reply:""}, "put").then((res) => {
              if (res.status !== 200) {
              alert('تأكد من الاتصال من الانترنت ');
              } else {
                  getAllComments();
                  setReplymessage("");
              }
              });
          }else {
              alert("لم يتم حذف ألرد");
          }
  }

  const reply = (comment)=>{
      senddata(`chat/reply_on_comment/${comment._id}`,{reply:replymessage}, "put").then((res) => {
          if (res.status !== 200) {
          alert('تأكد من الاتصال من الانترنت ');
          } else {
              getAllComments();
              setReplymessage("");
          }
          });
  }

  const getAllVideoWatch = ()=>{
    senddata(`tracktime/get_all_time_for_video/${video.id}`,{}, "get").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
        } else {
          setAllWatches(res.data);
          console.log("res",res.data);
        }
        });
  }

  const addMissenStudents = ()=>{
    senddata(`tracktime/add_missen_students/${video.id}`,{}, "get").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
        } else {
          console.log("res",res.data);
          getAllVideoWatch();
        }
    });
  }

  const printList = () => {
    let printContent = `
      <html>
        <head>
          <title>قائمة المشاهدات</title>
          <style>
            body { font-family: Arial, sans-serif; direction: rtl; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #e9ad03; padding: 8px; text-align: center; }
            th { background: #f9e5a3; }
          </style>
        </head>
        <body>
          <h2 style="text-align:center;">قائمة المشاهدات</h2>
          <table>
            <thead>
              <tr>
                <th>اسم الطالب</th>
                <th>رقم الموبايل</th>
                <th>وقت المشاهدة (دقيقة)</th>
              </tr>
            </thead>
            <tbody>
    `;

    allWatches.forEach(item => {
      const mobileMatch = item.videoname.match(/(\d{8,15})$/);
      const mobile = mobileMatch ? mobileMatch[1] : "—";
      printContent += `
        <tr>
          <td>${item.studentname}</td>
          <td>${mobile}</td>
          <td>${item.timewatched}</td>
        </tr>
      `;
    });

    printContent += `
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };




  // edit video
  const handleEditVideo = ()=>{
    if (!newUrl){
      return
    }
    senddata(`video/updateVideo/${course._id}/${video._id}`,{videoId:newUrl}, "put").then((res) => {
      if (res.status !== 200) {
      alert('تأكد من الاتصال من الانترنت ');
      } else {
          alert("تم التعديل ");
      }
      });
  }

  // 25/7
  const getAllCodes =()=>{
        senddata(`video/getcodes/${video.id}`,{}, "GET").then((res) => {
          if (res.status !== 200) {
            alert('حدث خطأ ');
          } else {
            setAllCodes(res.data);
          }
          });
    }

  const createCodes =()=>{
        console.log(video);
        senddata(`video/createcode/${video.id}`,{}, "PUT").then((res) => {
          if (res.status !== 200) {
            alert('تأكد من الاتصال بالانترنت ');
          } else {
            getAllCodes();
          }
          });
    }


    // 25/8
    // uploadFile
    const uploadFile = async () => {
      if (!selectedFile) return alert("يرجى اختيار ملف");

      const data = new FormData();
      data.append("file", selectedFile);
      data.append("type", fileType);

      try {
        sendFormData(`video/addFileToVideo/${course._id}/${video.id}`,data, "POST").then((res) => {
            if (res.status !== 200) {
              alert('تأكد من الاتصال بالانترنت ');
            } else {
              alert("تم الرفع بنجاح")
            }
            });
      } catch (error) {
        console.error(error);
        alert("خطأ في الاتصال بالخادم");
      }
    };


    const addAdditionalVideo = async () => {
      if (!additionalVideoId) return alert("يرجى ادخال فيديو");

      try {
        senddata(`video/addAdditionalVideoToVideo/${course._id}/${video.id}`,{videoId:additionalVideoId}, "POST").then((res) => {
            if (res.status !== 200) {
              alert('تأكد من الاتصال بالانترنت ');
            } else {
              alert("تم الاضافة بنجاح")
            }
            });
      } catch (error) {
        console.error(error);
        alert("خطأ في الاتصال بالخادم");
      }
    };

    const deleteAdditionalVideo = async (link) => {
      if (!link) return alert("يرجى ادخال فيديو");

      try {
        senddata(`video/deleteAdditionalVideoToVideo/${course._id}/${video.id}`,{videoUrl:link}, "POST").then((res) => {
            if (res.status !== 200) {
              alert('تأكد من الاتصال بالانترنت ');
            } else {
              alert("تم الحذف بنجاح")
            }
            });
      } catch (error) {
        console.error(error);
        alert("خطأ في الاتصال بالخادم");
      }
    };

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
      <div className='headers  '>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      {/* video details */}
      <div className='flex flex-col items-center'>
          <h2 className='border-b-2 border-[#e9ad03]'>تفاصيل الفيديو</h2>
          <div className=' flex flex-col items-center w-[70%] mt-6'>
            <iframe 
                src={video.videoURL} 
                className='w-full lg:w-[50%]'
                allow="autoplay; fullscreen; picture-in-picture" 
                allowFullScreen
                title="Vimeo Video Player"
              ></iframe>
          </div>
          <p>{video.videoURL}</p>
          <input value={newUrl} onChange={(e)=>{setNewUrl(e.target.value)}} className='text-black mt-2' />
          <button className='border-red-500 border-solid border-2 mt-4' onClick={handleEditVideo}>تعديل</button>
          <div className='flex flex-row justify-between w-[60%] mt-2'>
              <p>{video.description}</p>
              <p>: العنوان</p>
          </div>
          <div className='flex flex-row justify-between w-[60%] mt-2'>
            <p>{video.type=="free"?"مجاني":"اشتراك"}</p>
          </div>
       </div>
            {/* navigation */}
       <div dir='rtl' className='w-full overflow-x-auto scrollbar-hidden mt-20'>
          <div className='flex flex-row  py-2 min-w-full w-fit '>
            <p onClick={()=>{setShowOptions(1)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==1?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> امتحانات  </p> 
            <p onClick={()=>{setShowOptions(2)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==2?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> تعليقات  </p> 
            <p onClick={()=>{setShowOptions(3)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==3?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> المشاهدات  </p> 
            <p onClick={()=>{setShowOptions(4)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==4?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> الاكواد  </p> 
            {/* 25/8 */}
            <p onClick={()=>{setShowOptions(5)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==5?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> الملفات </p>
            {/* 25/9 */}
            <p onClick={()=>{setShowOptions(6)}} className={`px-7 py-2 mb-4 w-fit rounded-full cursor-pointer mx-3 ${showOptions==6?"bg-[#eb0000]":"bg-[#e9ad03]"}`}> فيديوهات اضافية </p>

          </div>
       </div>
       {/* add exam */}
      {showOptions==1&&<div className='w-[70%] ml-auto mr-auto mt-10'>
        <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto '>التدريب </h2>
        <div className='flex flex-row'>
          {exerciseId&&<p onClick={getExamInVideo} className={`px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto mt-8`} >عرض التديب </p> }
          <p onClick={habdleExercise} className={`${exerciseId? "bg-[#e9ad03]":"bg-[#da0000]"} px-7 py-1 w-fit rounded-full cursor-pointer ml-auto mt-8 `} >{exerciseId?"حذف التدريب":"اضافة تدريب"} </p> 
        </div>
      </div>}

        {/* comments */}
      {
        showOptions==2 && comments?.length&&
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5   gap-4 w-[80%] ml-[10%] '>
        <div className='mt-5'>
        <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto '>التعليقات </h2>
          {
            comments.map((comment,key)=>{
              return(
                <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                   <div className="grid grid-cols-1 rever gap-4">
                   <p className=' text-center text-[#e9ad03]'>{" " +key+1} </p>
                   <p dir='rtl' > 👈 {comment.message}</p>
                   {comment.reply && <p dir='rtl' > 💬 {comment.reply}</p>}
                   {showRply && (currentReply ==key) && <textarea dir='rtl' placeholder='اضف الرد' className='w-[90%] ml-[5%] rounded-xl text-black p-2' value={replymessage} onChange={(e)=>{setReplymessage(e.target.value)}} /> }
                  </div>
                  <div className='p-3'>
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                          {/* pdf==url */}
                          <p onClick={()=>{deleteComment(comment)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                          {showRply && currentReply ==key && <p onClick={()=>{reply(comment)}} className='mr-4 text-lg cursor-pointer '>👍</p>}
                          {!comment.reply && <p onClick={()=>{ setShowRply(!showRply); setCurrentReply(key); }} className='mr-4 text-lg cursor-pointer '>{showRply && currentReply ==key ? "❌":"💬"  }</p>}
                          {comment.reply && <p onClick={()=>{ setShowRply(!showRply); setCurrentReply(key); }} className='mr-4 text-lg cursor-pointer '>{showRply && currentReply ==key ? "❌":"✏️"  }</p>}
                        </div>
                      </div>
                   </div>
                </div>
              )
            })
          }
        </div>
        </div>
        }

        {
          showOptions==3 && allWatches.length > 0 && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                <div className='text-base w-[250px] text-center'>اسم الطالب</div>
                <div className='text-base w-[180px] text-center'>رقم ولي الامر</div>
                <div className='text-base w-[150px] text-center'>وقت المشاهدة</div>
              </div>
              {
                allWatches.map((item) => {
                  // استخراج رقم الموبايل من آخر جزء في اسم الفيديو
                  const mobileMatch = item.videoname.match(/(\d{8,15})$/);
                  const mobile = mobileMatch ? mobileMatch[1] : "—";
                  
                  return (
                    <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit' key={item._id}> 
                      <div dir='rtl' className='text-base w-[250px] text-center'>{item.studentname}</div>   
                      <div dir='ltr' className='text-base w-[180px] text-center'>{mobile}</div>   
                      <div dir='rtl' className='text-base w-[150px] text-center'>{item.timewatched} دقيقة</div>   
                    </div>
                  )
                })
              }                    
            </div>
          )
        }

          {
            showOptions==3 && <div className='flex flex-row mt-10'>
              <p onClick={addMissenStudents} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer hover:opacity-70 m-10'>إضافة الطلاب الغائبين</p>
              <p onClick={printList} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer hover:opacity-70 m-10'>تنزيل pdf</p>
            </div>
          }

          {showOptions==4&&<div className='flex flex-col items-center mt-10 mb-40'>
        <h2 className='border-b-2 border-[#e9ad03] mb-5'>الأكواد </h2>
        <div className='flex flex-row justify-between w-[70%] mt-4'>
          <p className=' ml-[9%]'>{allCodes.length}</p>
          <p>: عدد الأكواد</p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={createCodes} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'>{"اضافة "}</p> 
          <p>: اضف كواد</p>
        </div>
        <div className='flex flex-row justify-between items-center w-[70%] mt-8'>
          <p onClick={()=>{navigate("/printCodes",{ state: {allCodes,title:video.description} });}} className='px-4 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mr-auto hover:opacity-70'>اذهب الي الطباعة</p> 
          <p>:  طباعة الأكواد </p>
        </div>
      </div>}

 {showOptions == 5 && (
  <div className='w-[70%] ml-auto mr-auto mt-10'>
    <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto'>الملفات</h2>

    {/* Add File Form */}
    <div className='border-2 border-[#e9ad03] rounded-2xl p-4 mt-4'>
      {selectedFile && <p className='mb-2'>📎 {selectedFile.name}</p>}

      <div className='mb-4'>
        <label className='block mb-1'>اختيار الملف</label>
        <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} className='bg-white text-black p-2 rounded w-full' />
      </div>

      <div className='flex justify-between'>
        <button onClick={uploadFile} className='px-6 py-2 bg-[#da0000] text-white rounded-full hover:opacity-80'>
          📤 رفع الملف
        </button>
        {selectedFile && (
          <button onClick={() => setSelectedFile(null)} className='px-6 py-2 bg-[#e9ad03] text-black rounded-full hover:opacity-80'>
            ❌ مسح الملف
          </button>
        )}
      </div>
    </div>

    {/* Display Existing Files */}
    <div className='mt-10'>
      <h3 className='border-b-2 border-[#e9ad03] mb-4'>الملفات الحالية:</h3>
      {uploadedFiles?.length > 0 ? (
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
          {uploadedFiles.map((file, index) => (
            <div key={index} className='border border-[#e9ad03] rounded-xl p-4 flex flex-col justify-between'>
              <p className='mb-2 text-[#e9ad03] font-semibold'>📄 الملف {index + 1} - ({file.type})</p>
              <a href={file.fileURL} target="_blank" rel="noopener noreferrer" className='text-blue-400 underline mb-2'>
                عرض الملف
              </a>
              {/* Optional: Add delete logic here if you implement backend delete route */}
              {/* <button className='text-red-500 hover:underline'>🗑️ حذف</button> */}
            </div>
          ))}
        </div>
      ) : (
        <p className='mt-4 text-center'>لا توجد ملفات حالياً</p>
      )}
    </div>
  </div>
  )}


  {showOptions == 6 && (
  <div className='w-[70%] ml-auto mr-auto mt-10'>
    <h2 className='border-b-2 border-[#e9ad03] mb-10 w-fit ml-auto mr-auto'>الفيدوهات الاضافية</h2>

    {/* Add File Form */}
    <div className='border-2 border-[#e9ad03] rounded-2xl p-4 mt-4'>
      <div className=' grid grid-cols-1 rever gap-4'>
        <input 
          type="text"
          value={additionalVideoId}
          onChange={(e) => setAdditionalVideoId(e.target.value)}
          className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
          placeholder='ال ID'
        />
      </div>
      <div className=' grid grid-cols-2 rever gap-4'>
        <p onClick={addAdditionalVideo} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mt-6 '>اضافة </p>
        <p></p>
      </div>
    </div>

    {/* Display Existing Files */}
    <div className='mt-10'>
      <h3 className='border-b-2 border-[#e9ad03] mb-4'>الفيدوهات الحالية:</h3>
      {additionalVideos?.length > 0 ? (
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
          {additionalVideos.map((link, index) => (
            <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
              <div className="grid grid-cols-1 rever gap-4">
                <iframe 
                  src={link} 
                  style={{
                    width: '100%'
                  }}
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowFullScreen
                  title="Vimeo Video Player"
                ></iframe>
              </div>
              <div className='p-3'>
                <div className='flex justify-between items-center'>
                  <div className='flex '>
                    <p onClick={()=>{deleteAdditionalVideo(link)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className='mt-4 text-center'>لا توجد فيديوهات اضافية حالياً</p>
      )}
    </div>
  </div>
  )}



    </div>
  )
}

export default Video

